import { render, staticRenderFns } from "./TaskMenu.vue?vue&type=template&id=21b251f0&scoped=true"
import script from "./TaskMenu.vue?vue&type=script&lang=js"
export * from "./TaskMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b251f0",
  null
  
)

export default component.exports